import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { View } from "../../View";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const SingleWavesPostcodesAction = ({ onCancel, onContinue, error }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      {error ? (
        <Button
          className={styles.blue}
          variant={"contained"}
          onClick={onCancel}
        >
          Ok
        </Button>
      ) : (
        <>
          <Button
            className={styles.yellow}
            variant={"contained"}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            className={styles.blue}
            variant={"contained"}
            onClick={onContinue}
          >
            Continue
          </Button>
        </>
      )}
    </View>
  );
};
